import React from "react";
import CheckBox from "@components/checkBox";
import { usePendingPrefill, useSetDefaultValue } from "@hooks";

export default function AcceptContractScheduleCheckbox({ ...props }) {
  const { setFieldValue, name, ...checkboxProps } = props;
  useSetDefaultValue(name, false);
  usePendingPrefill(name);

  return (
    <div>
      <label>
        <CheckBox {...checkboxProps} name={name}>
          <strong>I understand and accept my Loan Contract and Repayment Schedule:</strong><br />
          <p>It is important you have read and understood what your loan contract obligations are.</p>
          <p>Please know we are committed to you as a responsible lender and have offered you a loan to help meet your objective and that is affordable based on the financial information you gave.</p>
        </CheckBox>
      </label>
    </div>
  );
}
